<template>
  <div class="sellPricingDetails">
      <!-- 导航栏 -->
        <van-nav-bar
            left-arrow
            fixed
           :border="false"
            safe-area-inset-top
            placeholder 
            title="定价详情"
            @click-left="leftClick"
        />
        <!--  内容 -->
        <div class="content">
            <div class="flex topInfo color1a">
                <h3>订单信息</h3>
                <h3 :style="{color:sellPricingData.status == 'UNDELIVERED'?'#ffb200':sellPricingData.status == 'DONE'?'#999999':'#1a1a1a'}">{{sellPricingData.status == "SUSPENSE"?'待审核':sellPricingData.status == "DONE"?'已完成':sellPricingData.status == "UNDELIVERED"?'待送货':sellPricingData.status == "FAIL"?'拒绝交易':'已取消'}}</h3>
                <div class="iconMai">卖</div>
            </div>
            <div class="flex btmInfo color9">
                <div class="time">下单时间 :</div>
                <div>{{sellPricingData.createTime | formatDate_}}</div>
            </div>
            <div class="flex btmInfo color9">
                <div class="time">订单编号 :</div>
                <div>{{sellPricingData.oid}}</div>
            </div>          
            <div class="flex btmInfo color9">
                <div class="time">货物类别 :</div>
                <div>{{sellPricingData.goods[0].name}}</div>
            </div>          
            <div class="flex btmInfo color9">
                <div class="time">定价重量(元/克) :</div>
                <div class="color6">{{sellPricingData.goods[0].weight.toFixed(2)}}</div>
            </div>          
            <div class="flex btmInfo color9">
                <div class="time">定价单价(元/克) :</div>
                <div class="color6">{{sellPricingData.goods[0].price}}</div>
            </div>          
            <div class="flex btmInfo color9">
                <div class="time">订单金额(元) :</div>
                <div class="color6">{{sellPricingData.goods[0].total.toFixed(2)}}</div>
            </div>          
            <div class="flex btmInfo color9 ">
                <div class="time">未交料重量 :</div>
                <div class="color9" :style="{color:sellPricingData.status == 'DONE'?'#999999':sellPricingData.status == 'FAIL'?'#999999':'#ffb200'}">{{sellPricingData.hasOwnProperty('freeWeight')? sellPricingData.freeWeight.toFixed(2):'0.00'}}</div>
            </div>
            <div v-for="(item) in sellPricingData.referenceInfoList" :key="item.openId">
                <div class="btmBorder"   v-if="sellPricingData.status == 'UNDELIVERED'?true:sellPricingData.status =='DONE'?true:false">
                    <div class="flex btmInfo color9" >
                        <div class="time">结算时间 :</div>
                        <div>{{item.time | formatDate_}}</div>
                    </div> 
                    <div class="flex btmInfo color9 " >
                        <div class="time">结算重量(g)</div>
                        <div>{{item.referenceWeight}}</div>
                    </div>
                    <div class="flex btmInfo color9 " >
                        <div class="time"></div>
                        <div @click="orderJieSuan(item)">详情 ></div>
                    </div>             
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
            data() {
                return {
                    sellPricingData:{}
                }
            },
            methods:{
                orderJieSuan(item){
                    this.$router.push({
                        name:"selldetails",
                        query:{
                            orderid:item.openId,
                            payType:this.sellPricingData.status == 'DONE'?'2':'0'
                            }
                    })
                },
                leftClick(){
                    this.$router.push({
                        name:'sellSettlement'
                    })
                }
            },
            created(){
                this.sellPricingData = JSON.parse(localStorage.getItem('SellPricingDetails'))
                console.log(this.sellPricingData);
            }
}
</script>

<style lang="scss" scoped>
::v-deep{
     .van-nav-bar{
        height: 80px;
        .van-nav-bar__content{
        line-height: 80px;
        height: 80px;
        .van-nav-bar__title{
            font-size: 34px;
        }
        .van-icon{
            font-size: 36px;
            color: #1a1a1a;
        }
        }
     }
}
.sellPricingDetails{
    height: 100%;
    background-color: #f5f5f5;
    .content{
        margin-top: 40px;
        width: 100%;
        padding: 20px 0;
        background-color: #fff;
    }
    .topInfo{
        border-bottom: 1px solid #ccc;
        padding: 0  30px 20px 100px ;
        position: relative;
        h3{
            font-size: 32px;
        }
        .iconMai{
            width: 50px;
            height: 50px;
            color: #fff;
            position: absolute;
            top: 0;
            left: 30px;
            font-size: 26px;
            text-align: center;
            line-height: 50px;
            border-radius: 50%;
            background-color: #fe462a;
        }
    }
    .btmInfo{
        padding: 20px 30px 0 30px;
    }
}
.flex{
    display: flex;
    justify-content: space-between;
    div{
        font-size: 32px;
    }
}
.color1a{
    color: #1a1a1a;
}
.color9{
    color: #999999;
}
.colorffb{
    color: #ffb200;
}
.color6{
    color: #666666;
}
.btmBorder{
    margin-top: 20px !important;
    border-top: 1px solid #666666;
}
</style>